module.exports = __webpack_public_path__ + "static/media/galerija_2015 (4).b641d20d.jpg";